// extracted by mini-css-extract-plugin
module.exports = {"banner":"_93444fe79c--banner--2GyF-","left-border":"_93444fe79c--left-border--19sH1","right-border":"_93444fe79c--right-border--T-wbW"};